import React, { useEffect, useState } from 'react';
import Dialog from '../../GenericComponents/dialog';
import { FoundationsButton } from '../../GenericComponents/button';
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster';
import { UsersbyStatus } from '../../Redux/Admin_Tasks/userAccountSlice';
import { FoundationsTextArea } from '../../GenericComponents/textarea';

interface RejectProps {
    isOpen: boolean;
    userId?: number | null;
    userByStatus?: UsersbyStatus;
    onReject: (args: { userId: number, comment: string }) => void;
    onRejectSuccess: () => void;
    onClose: () => void;
    onCommentChange: (comment: string) => void;
}

const Reject: React.FC<RejectProps> = ({
    isOpen,
    userId,
    userByStatus,
    onReject,
    onRejectSuccess,
    onCommentChange,
    onClose
}) => {
    const [fullName, setFullName] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [loading, setLoading] = useState(false);
    const [comment, setComment] = useState('');
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (isOpen) {
            setComment('');
        }
        if (userByStatus?.usersData) {
            const user = userByStatus.usersData.find((user) => String(user.Id) === String(userId));
            if (user) {
                setFullName(user.FullName || '');
                setEmailAddress(user.EmailAddress || '');
            }
        }
    }, [isOpen, userByStatus, userId]);


    useEffect(() => {
        if (userByStatus?.usersData) {
            const user = userByStatus.usersData.find((user) => String(user.Id) === String(userId));
            if (user) {
                setFullName(user.FullName || '');
                setEmailAddress(user.EmailAddress || '');

            }
        }
    }, [userByStatus, userId]);

    const handleReject = async () => {
        if (!userId) return;
        setLoading(true);
        setError(null);
        try {
            await onReject({ userId, comment });
            onRejectSuccess();
            const message = `User account: ${fullName.toUpperCase()} has been rejected successfully.`;
            FoundationsGenericToaster('success', message);
            onClose();
        } catch (err) {
            console.error(err);
            FoundationsGenericToaster('error', "Error rejecting user account: <strong>" + fullName + "</strong>.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Dialog
                isOpen={isOpen}
                title="Reject User Account"
                width={440}
                height="auto"
                zIndex={101}
                onClose={onClose}
                buttons = {[
                    {
                        label: "Cancel",
                        id: "cancelButton",
                        onClick: onClose, // Function to close the dialog
                        className: "ui-button ui-corner-all ui-widget app-button negative",
                    },
                    {
                        label: "Reject User",
                        id: "deleteButton",
                        onClick: handleReject, // Function to reject the user
                        className: "ui-button ui-corner-all ui-widget app-button",
                        disabled: loading, // Disable button when loading
                    },
                ]}
            >
                {userId && (
                    <div id="reject_user_dialog_wrapper">
                        <table className="input-form-table-popup-window">
                            <tbody>
                                  <tr>
                                    <td className="left" style={{ width: '30%' }}>
                                        <div>Name:</div>
                                    </td>
                                    <td className="right">
                                        <div id="label_reject_user_fullname" className="strong">{fullName}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="left">
                                        <div>Email:</div>
                                    </td>
                                    <td className="right">
                                        <div id="label_delete_user_email" className="strong">{emailAddress}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="left">
                                        <div>Comment:</div>
                                        <div className="field-optional">(optional)&nbsp;</div>
                                    </td>
                                    <td className="right">
                                        <FoundationsTextArea
                                            id="textarea_reject_user_comment"
                                            type="text"
                                            cols={30}
                                            rows={3}
                                            inputClasses="field-user-reject"
                                            value={comment}
                                            onInput={(e: any) => {
                                                const newComment = e.target.value;
                                                setComment(newComment);         // Update local state
                                                onCommentChange(newComment);    // Pass comment back to parent
                                            }}
                                        />
                                        <div className="field-optional">
                                            Comment will <strong></strong> be emailed to the user.
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <span
                            id="delete_user_account_loading"
                            className={`ajax-loading-box popup-loading ${loading ? '' : 'hide'}`}
                        >
                            <span className="ajax-loading-image">Processing...</span>
                        </span>
                    </div>

                )}
            </Dialog>
        </>
    );
};

export default Reject;





